module.exports = __webpack_public_path__ + "img/rectangularTrapezoidVertical.aabe1bae.svg";